import {
  COMMAS_DISPLAY_NAME,
  commasDetailsFromFields,
  prepareCommasFields
} from './commas-integration-form';
import OriginalTextInput from '@groovepages/gd-ui-kit/components/TextInput';
import { createCommasEnvironmentInput } from './commas-environment-select';

export function createAccountPaymentGatewayModal(OriginalPaymentGatewayModal, { axios, userRegion }) {
  return {
    extends: OriginalPaymentGatewayModal,

    provide() {
      return { commasGatewayModal: this };
    },

    components: {
      TextInput: createCommasEnvironmentInput(OriginalTextInput)
    },

    computed: {
      availableIntegrations() {
        if (userRegion === 'brazil') {
          return this.paymentIntegrations.filter((integration) =>
            ['paypal_commerce', 'stripe', 'commas'].includes(integration.name)
          );
        }

        return this.paymentIntegrations.filter((integration) =>
          this.isGroovester(integration.groove_only)
        );
      },

      formattedFormfields() {
        if (this.selectedIntegrationType === 'commas') {
          return commasDetailsFromFields(this.formfields);
        }

        return this.formfields.reduce((details, field) => {
          details[field.key] = field.value;
          return details;
        }, {});
      }
    },

    methods: {
      getFields(fields, name, displayName) {
        OriginalPaymentGatewayModal.methods.getFields.call(
          this,
          fields,
          name,
          displayName
        );

        if (name === 'commas') {
          // Keep the API strict while repairing stale catalog definitions and
          // making Commas' test/QA terminology unambiguously map to sandbox.
          this.formfields = prepareCommasFields(this.formfields);
          this.selectedIntegrationTitle = this.$t(
            'frontend_groovesell_connect_your_account',
            { gateway: COMMAS_DISPLAY_NAME }
          );
          this.selectedIntegrationName = COMMAS_DISPLAY_NAME;
        }
      },

      async getintegrations() {
        const genericCoreUrl = `${window.config.apiUrl.split('/api')[0]}/api/groovedigital`;
        const { data } = await axios.get(
          `${genericCoreUrl}/paymentintegrationdata/private`
        );

        this.paymentIntegrations = data.map((integration) => {
          if (integration.name !== 'commas') return integration;

          // The private API exposes Commas only to exact allowlisted users. Mark
          // that returned tile usable even when an allowed user is not on a
          // groovedigital.com email domain.
          return {
            ...integration,
            display_name: COMMAS_DISPLAY_NAME,
            groove_only: 0
          };
        });
      }
    }
  };
}
